window.GoogleTranslationAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);


    self.detectLanguage = function (text) {
        var defer = $q.defer();

        text = text || "";

        if (['sous chef', 'busser/runner'].indexOf(text.toLowerCase()) > -1) {
            defer.resolve('en');
        }
        else {
            _protected.request("https://www.googleapis.com/language/translate/v2/detect", "GET", {
                key: publicConfiguration.keys.google.services,
                q: text
            }, true)
                .then(function (result) {
                    if (result.data && result.data.data && result.data.data.detections && result.data.data.detections[0] && result.data.data.detections[0][0]) {
                        var lang = result.data.data.detections[0][0].language || "";

                        if (lang && lang != 'und') {
                            defer.resolve(lang);
                        }
                        else {
                            result = result || {};
                            result['code'] = "UNDEFINED_LANG";
                            defer.reject(result);
                        }
                    }
                    else {
                        defer.reject(result);
                    }
                })
                .catch(function (err) {
                    defer.reject(err);
                });
        }


        return defer.promise;
    };

})();
